import { createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';

import { dividerColor } from 'src/data/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subheader: {
      marginRight: 'auto',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      borderBottom: `1px solid ${dividerColor}`,
      padding: '16px 24px',
      textTransform: 'capitalize',
    },
    title: {
      fontSize: 26,
    },
  })
);

interface SubheaderProps {
  title: string;
  children?: React.ReactNode;
}

const Subheader = ({ title, children }: SubheaderProps) => {
  const classes = useStyles();

  return (
    <Grid item className={classes.subheader}>
      <Grid item>
        <Typography className={classes.title}>{title}</Typography>
      </Grid>
      {children}
    </Grid>
  );
};

export default Subheader;
